import React, { Component, useState, useEffect, useRef } from 'react';
import CalendarDays from './calendar-days';
import './calendar.scss';
import TickIcon from 'src/assets/images/common/white-tick.svg';
import { FormGroup, FormControlLabel, Switch } from '@mui/material';
import { Row, Col } from 'react-bootstrap';

const dateRangePresets = [
  { label: "Last Week", days: 7, type: "thisWeek" },
  { label: "Last 2 Weeks", days: 14, type: "last14Days" },
  { label: "Last 4 Weeks", days: 28, type: "last28Days" },
  { label: "Last 6 Weeks", days: 42, type: "last42Days" },
  { label: "Last 8 Weeks", days: 56, type: "last56Days" },
  { label: "Custom", days: 35, type: "custom" }
];

export default class PathCalendar extends Component {
  constructor(props) {
    super(props);

    this.activeDateRange = props?.history ? props?.history?.activePreset : '';

    this.BiweeklyDates = props?.weeklyBiweelyData.BiweeklyDate ? props?.weeklyBiweelyData.BiweeklyDate : '';
    this.LastWeekDate = props?.weeklyBiweelyData.WeeklyData ? props?.weeklyBiweelyData.WeeklyData : '';

    this.weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    this.months = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];

    this.biWeek = false;
    this.initialClick = true;

    const getLastWeekRange = () => {
      const today = new Date();
      const currentMonday = new Date(today);
      currentMonday.setDate(today.getDate() - today.getDay() + 1); 
      
      const lastWeekMonday = new Date(currentMonday);
      lastWeekMonday.setDate(currentMonday.getDate() - 8); 
      
      const lastWeekSunday = new Date(lastWeekMonday);
      lastWeekSunday.setDate(lastWeekMonday.getDate() + 6); 
      
      return { start: lastWeekMonday, end: lastWeekSunday };
    };

    const lastWeekRange = getLastWeekRange();
    
    const isSQP = String(props?.currentPath || window.location.pathname || '').includes('amazon/search-query-performance');
    const defaultPreset = isSQP ? 'last56Days' : 'thisWeek';

    // Derive default range based on preset
    const lastWeekDayISO = this.LastWeekDate;
    const lastWeekDay = new Date(lastWeekDayISO);
    const endDayDefault = new Date(lastWeekDay);
    endDayDefault.setDate(lastWeekDay.getDate() - 1);
    const daysForPreset = defaultPreset === 'last56Days' ? 56 : defaultPreset === 'last28Days' ? 28 : 7;
    const startDayDefault = new Date(endDayDefault);
    startDayDefault.setDate(endDayDefault.getDate() - (daysForPreset - 1));

    this.backup = props?.history ? global.structuredClone(props.history) : {
      currentDay: startDayDefault,
      endDay: endDayDefault
    }
    this.changedDatesss = props?.history ? global.structuredClone(props.history) : {
      currentDay: startDayDefault,
      endDay: endDayDefault,
      activePreset: defaultPreset
    };
    this.currentDateUpdated = true;
    const currentMonth = new Date();
    currentMonth.setDate(1); // Set to the first day of the current month

    const lastWeekDate = new Date(this.LastWeekDate);
    const firstOfCurrentMonth = new Date(lastWeekDate.getFullYear(), lastWeekDate.getMonth() - 1, 1);
    //const previousMonth = new Date(firstOfCurrentMonth);
    // previousMonth.setDate(0);
    // previousMonth.setDate(1); 
    const previousMonth = new Date(currentMonth);
    previousMonth.setMonth(currentMonth.getMonth() - 1);

    this.state = {
      currentDay: currentMonth,
      endDay: new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 7)),
      previousMonth,
      activePreset: this.activeDateRange ? this.activeDateRange : defaultPreset,
    }
  }

  changeCurrentDay = (day) => {
    if (this.currentDateUpdated) {
      this.changedDatesss['currentDay'] = day.date;
      this.changedDatesss['endDay'] = day.date;
      this.currentDateUpdated = false;
      this.changedDatesss['activePreset'] = 'custom';
    }
    else {
      let data = new Date(new Date(day.date).setDate(new Date(day.date).getDate()))
      let endDate = new Date(new Date(day.date).setDate(new Date(day.date).getDate() - 1))
      if (endDate.toDateString() === this.changedDatesss['currentDay'].toDateString()) {
        this.changedDatesss['currentDay'] = data;
      }
      else if (data.toDateString() < this.changedDatesss['currentDay'].toDateString() && data.getDay() !== this.changedDatesss['currentDay'].getDay()) {
        this.changedDatesss['endDay'] = this.changedDatesss['currentDay'];
        this.changedDatesss['currentDay'] = data;
      }
      else if (data.getDay() !== this.changedDatesss['currentDay'].getDay()) {
        this.changedDatesss['endDay'] = data;
        this.currentDateUpdated = true;
      }
    }
    this.setState(this.state);
    this.props.onDataReceive(global.structuredClone(this.changedDatesss))
  }

  previousDay = () => {
    this.setState((prevState) => {
      const newPreviousMonth = new Date(prevState.previousMonth);
      newPreviousMonth.setMonth(newPreviousMonth.getMonth() - 1);
  
      const newCurrentMonth = new Date(prevState.currentDay);
      newCurrentMonth.setMonth(newCurrentMonth.getMonth() - 1);
  
      return { previousMonth: newPreviousMonth, currentDay: newCurrentMonth };
    });
  };
  
  nextDay = () => {
    this.setState((prevState) => {
      const newPreviousMonth = new Date(prevState.previousMonth);
      newPreviousMonth.setMonth(newPreviousMonth.getMonth() + 1);
  
      const newCurrentMonth = new Date(prevState.currentDay);
      newCurrentMonth.setMonth(newCurrentMonth.getMonth() + 1);
  
      return { previousMonth: newPreviousMonth, currentDay: newCurrentMonth };
    });
  };
  

  nextMonth = () => {
    this.setState((prevState) => {
      const newCurrentMonth = new Date(prevState.currentMonth);
      newCurrentMonth.setMonth(newCurrentMonth.getMonth() + 1);
      const newPreviousMonth = new Date(newCurrentMonth);
      newPreviousMonth.setMonth(newCurrentMonth.getMonth() - 1);
      return { currentMonth: newCurrentMonth, previousMonth: newPreviousMonth };
    });
  };

  previousMonth = () => {
    this.setState((prevState) => {
      const newCurrentMonth = new Date(prevState.currentMonth);
      newCurrentMonth.setMonth(newCurrentMonth.getMonth() - 1);
      const newPreviousMonth = new Date(newCurrentMonth);
      newPreviousMonth.setMonth(newCurrentMonth.getMonth() - 1);
      return { currentMonth: newCurrentMonth, previousMonth: newPreviousMonth };
    });
  };

  setLastDays = (days, type) => {
    const today = new Date();
    const lastWeekDay = new Date(this.LastWeekDate);

    const endDay = new Date(lastWeekDay);
    endDay.setDate(lastWeekDay.getDate() - 1);
    
    const startDay = new Date(endDay);
    startDay.setDate(endDay.getDate() - (days - 1));
  
    this.changedDatesss = {
      currentDay: startDay,
      endDay: endDay
    };
  
    this.setState({ activePreset: type });
    this.props.onDataReceive({ currentDay: startDay, endDay: endDay, activePreset: type === 'custom' ? '' : type });
  };

  render() {
    return (
     <section>
      <section className='d-flex gap-10'>
        <div className='static_ranges_list'>
          <h3 class="f-0092FF f-13 f-w-600 px-2">Date Presets</h3>
          <ul>
            {dateRangePresets.map((preset) => (
              <li
                className={`justify-content-between ${this.state.activePreset === preset.type ? "active" : ""}`}
                onClick={() => this.setLastDays(preset.days, preset.type)}
                key={preset.type}
              >
                {preset.label}
                {this.state.activePreset === preset.type && <img src={TickIcon} alt="select-date" className="slcd-dat" />}
              </li>
            ))}
          </ul>
        </div>

        <section className='d-flex gap-20'>
          <div className="calendar">
            <div className="calendar-header">
              <div className="tools">
                <button onClick={this.previousDay} className='bg-white'>
                  {/* <span className="material-icons text-dark">
                    arrow_back
                  </span> */}
                  <div className='d-flex text-dark'>
                    <i className="fas fa-arrow-left" style={{fontSize:'12px',fontWeight:'600'}}></i>
                  </div>                 
                </button>
                <p style={{ fontWeight: 'bold', width: '150px', textAlign: 'center' }}>
                  {this.months[this.state.previousMonth.getMonth()]} {this.state.previousMonth.getFullYear()}
                </p>
                <span></span>
              </div>
            </div>
            <div className="calendar-body">
              <div className="table-header">
                {
                  this.weekdays.map((weekday) => {
                    return <div className="weekday"><p>{weekday}</p></div>
                  })
                }
              </div>
              {console.log('PathCalendar passing path to CalendarDays:', this.props.currentPath)}
              <CalendarDays day={this.state.previousMonth} changedDates={this.changedDatesss} end={this.state.endDay} biWeek={this.biWeek} changeCurrentDay={this.changeCurrentDay} BiweeklyDate={this.BiweeklyDates} lastWeekDay={this.LastWeekDate} compare={this.props.compare} currentPath={this.props.currentPath} />
            </div>
          </div>
          <div className="calendar">
            <div className="calendar-header">

              <div className="tools">
                <span></span>
                <p style={{ fontWeight: 'bold', width: '150px', textAlign: 'center' }}>{this.months[this.state.currentDay.getMonth()]} {this.state.currentDay.getFullYear()}</p>
                <button onClick={this.nextDay} className='bg-white'>
                  <div className='d-flex text-dark'>
                    <i className="fas fa-arrow-right" style={{fontSize:'12px',fontWeight:'600'}}></i>
                  </div>              
                </button>
              </div>
            </div>
            <div className="calendar-body">
              <div className="table-header">
                {
                  this.weekdays.map((weekday) => {
                    return <div className="weekday"><p>{weekday}</p></div>
                  })
                }
              </div>
              {console.log('PathCalendar passing path to CalendarDays (current month):', this.props.currentPath)}
              <CalendarDays day={this.state.currentDay} changedDates={this.changedDatesss} end={this.state.endDay} biWeek={this.biWeek} changeCurrentDay={this.changeCurrentDay} BiweeklyDate={this.BiweeklyDates} lastWeekDay={this.LastWeekDate} compare={this.props.compare} currentPath={this.props.currentPath} />
            </div>
          </div>
        </section>

       
      </section>
      <Row className='py-2'>
          <Col sm={12} className='d-flex align-items-center justify-content-start'>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  sx={{
                    transform: 'scale(0.8)',
                  }}
                  checked={this.props.compare}
                  onChange={(e) => {
                    //this.setCompare(e.target.checked);
                    // this.setState({ compare: e.target.checked });
                    this.props.setCompare(e.target.checked);
                  }}
                />
              }
              label="Compare"
              labelPlacement="start"
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontSize: '12px',
                  fontWeight: '600',
                  fontFamily: '"Open Sans", sans-serif',
                },
              }}
            />
          </FormGroup>
          </Col>
        </Row>
      </section>
    )
  }
}

// changeCurrentDay = (day) => {
//   if (this.currentDateUpdated) {
//     this.changedDatesss['currentDay'] = day.date;
//     this.changedDatesss['endDay'] = day.date;
//     this.currentDateUpdated = false;
//     this.changedDatesss['activePreset'] = 'custom'; // Set activePreset to 'custom'
//   } else {
//     let data = new Date(new Date(day.date).setDate(new Date(day.date).getDate()));
//     let endDate = new Date(new Date(day.date).setDate(new Date(day.date).getDate() - 1));
//     if (endDate.toDateString() === this.changedDatesss['currentDay'].toDateString()) {
//       this.changedDatesss['currentDay'] = data;
//     } else if (data.toDateString() < this.changedDatesss['currentDay'].toDateString() && data.getDay() !== this.changedDatesss['currentDay'].getDay()) {
//       this.changedDatesss['endDay'] = this.changedDatesss['currentDay'];
//       this.changedDatesss['currentDay'] = data;
//     } else if (data.getDay() !== this.changedDatesss['currentDay'].getDay()) {
//       this.changedDatesss['endDay'] = data;
//       this.currentDateUpdated = true;
//     }
//   }
//   this.setState(this.state);
//   this.props.onDataReceive(global.structuredClone(this.changedDatesss));
// }